import type {
  CityOption,
  DoctorOption,
  LocationOption,
  ServiceOption,
  SpecialtyOption,
} from '@/lib/nomenclature/appointmentRepo';

/** The five cascading selections, in mobile order. */
export interface BookingSelection {
  city: CityOption | null;
  location: LocationOption | null;
  specialty: SpecialtyOption | null;
  service: ServiceOption | null;
  doctor: DoctorOption | null;
}

export type BookingMode = 'first' | 'manual';

/** A resolved, bookable slot (shared by first-available and manual flows). */
export interface ResolvedSlot {
  doctorName: string;
  /** MEDIS physician UUID. */
  physicianId: string;
  /** Local physician id (for price lookup); null if unknown. */
  physicianDbId: number | null;
  serviceName: string;
  /** Resolved service (may differ from the selected one in first-available mode). */
  service: ServiceOption | null;
  /** MEDIS entity UUID from the timetable day. */
  entityId: string;
  day: Date;
  start: Date;
  end: Date;
  locationName: string;
  cityName: string;
}

export const EMPTY_SELECTION: BookingSelection = {
  city: null,
  location: null,
  specialty: null,
  service: null,
  doctor: null,
};
